export default (theme) => ({
  root: {
    marginTop: theme.spacing(0.5),
  },
  text: {
    wordBreak: 'break-word',
  },
});
